"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M8 16H12.004C12.004 17.059 11.107 17.917 10.002 17.917C8.896 17.917 8 17.059 8 16ZM16.9305 14.275C17.1265 14.601 16.8805 15 16.4955 15H3.5035C3.1185 15 2.8725 14.601 3.0695 14.275C3.5495 13.477 3.9995 11.972 3.9995 11.05V9C3.9995 6.183 5.7895 3.716 8.5345 3.167C8.7775 3.118 8.9555 2.92 8.9555 2.682V3C8.9555 2.447 9.4225 2 9.9995 2C10.5765 2 11.0435 2.447 11.0435 3V2.682C11.0435 2.92 11.2225 3.118 11.4655 3.167C14.2095 3.716 15.9995 6.183 15.9995 9V11.051C15.9995 11.972 16.4505 13.477 16.9305 14.275Z",
    fill: "#727B7F"
  }));
};